import {
  POS_TYPES,
  type PosType,
} from '../../../gateways/breadstack/posConnectionApis'

export interface PosProviderMeta {
  id: PosType
  name: string
  description: string
  // Served from apps/breadstack-crm/src/assets/icons via viteStaticCopy.
  logoSrc: string
}

export const POS_PROVIDER_META: Record<PosType, PosProviderMeta> = {
  [POS_TYPES.COVA]: {
    id: POS_TYPES.COVA,
    name: 'Cova',
    description:
      'Cannabis POS and retail management platform with compliance tracking.',
    logoSrc: '/icons/logo/logo_wp_cova.svg',
  },
  [POS_TYPES.GREENLINE]: {
    id: POS_TYPES.GREENLINE,
    name: 'Greenline',
    description:
      'All-in-one cannabis retail POS with built-in compliance and reporting.',
    logoSrc: '/icons/logo/logo_wp_greenline.svg',
  },
}

export const POS_PROVIDER_LIST: PosProviderMeta[] = [
  POS_PROVIDER_META[POS_TYPES.COVA],
  POS_PROVIDER_META[POS_TYPES.GREENLINE],
]

export const isPosType = (value: unknown): value is PosType =>
  value === POS_TYPES.COVA || value === POS_TYPES.GREENLINE
